import styled from '@emotion/styled'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import WarningIcon from '@mui/icons-material/Warning'
import { motion, AnimatePresence } from 'framer-motion'
import { colors } from '@global/constants/colors'
import { ErrorType, ERROR_MESSAGES } from './utils'

const ValidationList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin-top: 0px;
`

const ValidationItem = styled(motion.li)`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 11px;
`

const ValidationMessage = styled.span<{ valid: boolean }>`
  color: ${props => (props.valid ? colors.green.main : colors.red.main)};
  margin-left: 8px;
`

export function NameValidator({ validationErrors }) {
  const validations = [
    {
      type: ErrorType.EMPTY,
      message: ERROR_MESSAGES[ErrorType.EMPTY],
      valid: !validationErrors.some(e => e.type === ErrorType.EMPTY),
    },
    {
      type: ErrorType.RESERVED_KEYWORD,
      message: ERROR_MESSAGES[ErrorType.RESERVED_KEYWORD],
      valid: !validationErrors.some(e => e.type === ErrorType.RESERVED_KEYWORD),
    },
    {
      type: ErrorType.LENGTH,
      message: ERROR_MESSAGES[ErrorType.LENGTH],
      valid: !validationErrors.some(e => e.type === ErrorType.LENGTH),
    },
    {
      type: ErrorType.START_WITH_DIGIT,
      message: ERROR_MESSAGES[ErrorType.START_WITH_DIGIT],
      valid: !validationErrors.some(e => e.type === ErrorType.START_WITH_DIGIT),
    },
    {
      type: ErrorType.INVALID_CHARACTERS,
      message: ERROR_MESSAGES[ErrorType.INVALID_CHARACTERS],
      valid: !validationErrors.some(e => e.type === ErrorType.INVALID_CHARACTERS),
    },
  ]

  return (
    <ValidationList>
      <AnimatePresence>
        {validations.map((validation, index) => (
          <ValidationItem
            key={index}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            {validation.valid ? (
              <CheckCircleIcon sx={{ width: '13px', height: '13px', color: colors.green.main }} />
            ) : (
              <WarningIcon sx={{ width: '13px', height: '13px', color: colors.red.main }} />
            )}
            <ValidationMessage valid={validation.valid}>{validation.message}</ValidationMessage>
          </ValidationItem>
        ))}
      </AnimatePresence>
    </ValidationList>
  )
}
